import { getMainDomain } from '@/tools/common';
import type { FleAppEnv, EnvURLMap } from '@/types/const/serviceEnv';

export const fleAppEnv: FleAppEnv = fleProcess.fleEnv;
type ServerType = 'java';
type BaseURLMap = {
  [K in ServerType]: EnvURLMap;
};
export const baseURLMap: BaseURLMap = {
  java: {
    dev: 'https://dev-gateway.fxqifu.net/pangu',
    qa: 'https://qa-gateway.fxqifu.net/pangu',
    prod: 'https://gateway.fxqifu.net/pangu',
  },
};

type codeType = number;
export const DataCode: Map<string, codeType> = new Map([
  ['SUCCESS', 2000],
  ['LOGIN_ERROR', 100003],
  ['INVALID_LOGIN', 60000013],
]);

export const BaseServiceType = 'java';
export const TokenKey = 'token';
export const BaseURL: string = baseURLMap[BaseServiceType][fleAppEnv] || '';

export type ApplicationType =
  | '88buys'
  | 'share'
  | 'home'
  | 'help'
  | 'cardStore'
  | 'liguanjia'
  | 'peliten'
  | 'csc'
  | 'cscUser'
  | 'login'
  | 'supplier'
  | 'fleAI'
  | 'newFleAI';
  
type ApplicationUrlMapType = {
  [K in ApplicationType]: EnvURLMap;
};

let domin = getMainDomain();
domin = domin === 'localhost' ? `88buys.com` : domin;

export const ApplicationUrlMap: ApplicationUrlMapType = {
  '88buys': {
    dev: 'https://qa.88buys.com',
    qa: 'https://qa.88buys.com',
    prod: 'https://88buys.com',
  },
  // 分享
  share: {
    dev: `https://dev-wanli.${domin}/share`,
    qa: `https://qa-wanli.${domin}/share`,
    prod: `https://wanli.${domin}/share`,
  },
  // 主页
  home: {
    dev: `https://dev-wanli.${domin}`,
    qa: `https://qa-wanli.${domin}`,
    prod: `https://wanli.${domin}`,
  },
  // 登录
  login: {
    dev: `https://dev-account.${domin}`,
    qa: `https://qa-account.${domin}`,
    prod: `https://account.${domin}`,
  },
  // 帮助中心
  help: {
    dev: 'https://dev-help.carpunion.com',
    qa: 'https://qa-help.carpunion.com',
    prod: 'https://help.carpunion.com',
  },
  // 卡券
  cardStore: {
    dev: `https://qa-cardstore.${domin}`,
    qa: `https://qa-cardstore.${domin}`,
    prod: `https://cardstore.${domin}`,
  },
  // 礼管家
  liguanjia: {
    dev: `https://qa-liguanjia.${domin}`,
    qa: `https://qa-liguanjia.${domin}`,
    prod: `https://liguanjia.${domin}`,
  },
  // 百礼腾
  peliten: {
    dev: 'https://qa-peliten-api.88buys.com',
    qa: 'https://qa-peliten-api.88buys.com',
    prod: 'https://peliten-api.88buys.com',
  },
  // 客服
  csc: {
    dev: 'https://dev-csc.88buys.com/service',
    qa: 'https://qa-csc.88buys.com/service',
    prod: 'https://csc.88buys.com/service',
  },
  // 客服-用户入口
  cscUser: {
    dev: 'https://dev-csc.88buys.com/customer/chart',
    qa: 'https://qa-csc.88buys.com/customer/chart',
    prod: 'https://csc.88buys.com/customer/chart',
  },
  // 供应商端
  supplier: {
    dev: `https://supplier.koudaiqifu.cn`,
    qa: `https://supplier.koudaiqifu.cn`,
    prod: `https://supplier.fxqifu.com`,
  },
  // 飞象AI
  fleAI: {
    dev: `https://qa-fle-ai.fxqifu.com`,
    qa: `https://qa-fle-ai.fxqifu.com`,
    prod: `https://fx-ai.fxqifu.com`,
  },
  // 飞象AI
  newFleAI: {
    dev: `http://qa-ai.88buys.com`,
    qa: `http://qa-ai.88buys.com`,
    prod: `http://fx-ai.88buys.com`,
  },
};

export const getApplicationUrl = (application: ApplicationType, router = '') => {
  return `${ApplicationUrlMap[application]?.[fleAppEnv]}${router}`;
};
